import React from "react";

const AdminPaymentGatewaysICon = ({ width, height, color }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0972 7.9732C11.0972 10.3065 9.17357 12.1978 6.79859 12.1978C4.42499 12.1978 2.5 10.3065 2.5 7.9732C2.5 5.64123 4.42499 3.75 6.79859 3.75C9.17357 3.75 11.0972 5.64123 11.0972 7.9732ZM25.6167 6.12291C26.6556 6.12291 27.5 6.95254 27.5 7.9732C27.5 8.99523 26.6556 9.82486 25.6167 9.82486H17.3973C16.357 9.82486 15.5126 8.99523 15.5126 7.9732C15.5126 6.95254 16.357 6.12291 17.3973 6.12291H25.6167ZM4.38471 19.9474H12.6041C13.6444 19.9474 14.4888 20.7771 14.4888 21.7991C14.4888 22.8198 13.6444 23.6508 12.6041 23.6508H4.38471C3.34444 23.6508 2.5 22.8198 2.5 21.7991C2.5 20.7771 3.34444 19.9474 4.38471 19.9474ZM23.2014 25.9722C25.5764 25.9722 27.5 24.081 27.5 21.749C27.5 19.4157 25.5764 17.5245 23.2014 17.5245C20.8278 17.5245 18.9028 19.4157 18.9028 21.749C18.9028 24.081 20.8278 25.9722 23.2014 25.9722Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export default AdminPaymentGatewaysICon;
